export default "__VITE_ASSET__jAA5oxqk__"